import React from 'react';
import { List } from 'immutable';

import { Node } from '@uncinc/react-drupal-core';
import { Accordion } from '@uncinc/uncinc-react-kitchen-sink';

import { TitleHeaderBlock } from '../../../components';

import './style.scss';

const ParagraphFAQ = ({ entity }) => {
  const title = entity.getIn(['field_title', 0, 'value']);

  return (
    <div>
      <TitleHeaderBlock
        title={title}
      >
        {entity.get('field_faq_items') ? (
          <Accordion className="FAQ__accordion">
            {entity.get('field_faq_items', List()).map((faqEntity) => {
              const id = faqEntity.getIn(['entity', 'nid', '0', 'value']);
              return (
                <Node
                  key={`a-item-${id}`}
                  entity={faqEntity.get('entity')}
                  viewMode="teaser"
                />
              );
            })}
          </Accordion>
        ) : null}
      </TitleHeaderBlock>
    </div>
  );
};

export default ParagraphFAQ;
